export default __webpack_public_path__ + "static/media/smoking.1349bb59.svg";